import styles from "./PulseLoader.module.css";

function PulseLoader({
  className = "",
  color = "",
  colorVar = "primary-color",
  size = 2,
}: {
  className?: string;
  color?: string;
  colorVar?: string;
  size?: number;
}): JSX.Element {
  const pulseColor = color ? color : `var(--${colorVar})`;

  return (
    <div className={`${styles.container} ${className}`}>
      <div
        style={{ "--size": `${size}rem`, "--color": pulseColor }}
        className={styles.pulse}
      />
    </div>
  );
}

export default PulseLoader;
